// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointFromJSON, DatapointToJSON, DatapointExcelOptionFromJSON, DatapointExcelOptionToJSON, DatapointTotalGroupExcelOptionFromJSON, DatapointTotalGroupExcelOptionToJSON, } from './';
export function DatapointsExcelRequestItemFromJSON(json) {
    return {
        'id': json['id'],
        'measures': !exists(json, 'measures') ? undefined : json['measures'].map(DatapointFromJSON),
        'dimensions': !exists(json, 'dimensions') ? undefined : json['dimensions'].map(DatapointFromJSON),
        'datapointExcelOptions': !exists(json, 'datapointExcelOptions') ? undefined : json['datapointExcelOptions'].map(DatapointExcelOptionFromJSON),
        'totalGroupExcelOptions': !exists(json, 'totalGroupExcelOptions') ? undefined : json['totalGroupExcelOptions'].map(DatapointTotalGroupExcelOptionFromJSON),
        'includeTotalExcelValues': !exists(json, 'includeTotalExcelValues') ? undefined : json['includeTotalExcelValues'],
        'sheetName': !exists(json, 'sheetName') ? undefined : json['sheetName'],
    };
}
export function DatapointsExcelRequestItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'measures': value.measures === undefined ? undefined : value.measures.map(DatapointToJSON),
        'dimensions': value.dimensions === undefined ? undefined : value.dimensions.map(DatapointToJSON),
        'datapointExcelOptions': value.datapointExcelOptions === undefined ? undefined : value.datapointExcelOptions.map(DatapointExcelOptionToJSON),
        'totalGroupExcelOptions': value.totalGroupExcelOptions === undefined ? undefined : value.totalGroupExcelOptions.map(DatapointTotalGroupExcelOptionToJSON),
        'includeTotalExcelValues': value.includeTotalExcelValues,
        'sheetName': value.sheetName,
    };
}
